<!--轮播图封装-->
<template>
    <div class="carousel-container">
        <div class="btn prev" @click="toggleImage('prev')">
            <i class="el-icon-arrow-left"></i>
        </div>
        <el-carousel
            ref="carousel"
            class="carousel"
            :autoplay="false"
            :height="height"
            :type="type"
            trigger="click"
            indicator-position="outside"
            arrow="never"
        >
            <el-carousel-item v-for="(item,index) in images" :key="index">
                <img
                    :src="item"
                    style="width: 100%;height: 100%;object-fit: scale-down"
                    alt
                />
            </el-carousel-item>
        </el-carousel>
        <div class="btn next" @click="toggleImage('next')">
            <i class="el-icon-arrow-right"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            default: () => []
        },
        height: {
            type: String,
            default: '600px'
        },
        type: {
            type: String,
            default: ''
        }
    },
    name: 'Carousel',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
        //切换图片
        toggleImage(type) {
            this.$refs.carousel[type]()
        }
    }
}
</script>


<style scoped lang="scss">
.carousel-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;

    .btn {
        cursor: pointer;
        padding: 8px;
        border: 1px solid #0079fe;
        font-size: 32px;
        border-radius: 4px;
        color: #0079fe;
        transition: all 0.3s cubic-bezier(0.1, 0.79, 0.61, 0.99);

        &:active {
            background: #0079fe;
            color: #fff;
        }
    }

    .carousel {
        width: calc(100% - 180px);

        :deep .el-carousel__button {
            height: 10px;
            border-radius: 100px;
            width: 20px;
            background: #000000;
        }

        :deep .is-active .el-carousel__button {
            background: #0079fe;
            width: 30px;
        }
    }
}

</style>
